















































import Button from '@/app/ui/components/Button/index.vue'
import DateTimePickerV2, {
  IDateRangeValue,
} from '@/app/ui/components/DateTimePickerV2/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CloseLine from '@/app/ui/assets/close_line.vue'
import PickupController from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'
import dayjs from 'dayjs'

@Component({
  components: {
    Modal,
    DateTimePickerV2,
    Button,
    CloseLine,
  },
})
class ModalExportCorporate extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: () => ({}) }) payload!: Record<string, any>

  controller = PickupController

  dateRange = <IDateRangeValue>{
    start: null,
    end: null,
  }

  public get decideDisableExportCorporateButton(): boolean {
    return (
      this.controller.isLoadingExportCorporate ||
      (!this.dateRange?.start || !this.dateRange?.end)
    )
  }

  public async exportCorporate(): Promise<void> {
    const fileName = `Corporate-${Utils.formatDateWithIDLocale(
      dayjs(),
      'YYYYMMDDHHmss'
    )}`
    const payload = {
      ...this.payload,
      fileName,
      dateFrom: Utils.formatDateWithIDLocale(
        <string>this.dateRange?.start?.toISOString(),
        'YYYY-MM-DD'
      ),
      dateTo: Utils.formatDateWithIDLocale(
        <string>this.dateRange?.end?.toISOString(),
        'YYYY-MM-DD'
      ),
    }

    this.controller.setLoadingExportCorporate(true);
    await this.controller.getExportCorporate(payload)
    .finally(() => {
      this.controller.setLoadingExportCorporate(false);
    })
    this.resetValue()
    this.$emit('cancel')
  }

  public resetValue(): void {
    this.dateRange = {
      end: null,
      start: null,
    }
  }

  @Watch('controller.isSuccessExportCorporate')
  onSuccessExportCorporate(data: boolean) {
    if (data) {
      this.resetValue()
      this.$emit('cancel')
    }
  }
}
export default ModalExportCorporate;
